var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", [_vm._v("Set the content accessibility")]),
      _vm._v(" "),
      _c("input-switch-component", {
        attrs: { label: "Secured access" },
        model: {
          value: _vm.isSecured,
          callback: function($$v) {
            _vm.isSecured = $$v
          },
          expression: "isSecured"
        }
      }),
      _vm._v(" "),
      _c("checkbox-list-component", {
        attrs: { config: _vm.listConfig },
        model: {
          value: _vm.currentOptions,
          callback: function($$v) {
            _vm.currentOptions = $$v
          },
          expression: "currentOptions"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41121e85", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41121e85","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/form-elements/ScopeSelectComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-41121e85","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/form-elements/ScopeSelectComponent.vue
// module chunks = 0